import DashX from '@dashx/browser'

export default DashX({
  publicKey: import.meta.env.VITE_DASHX_PUBLIC_KEY,
  targetEnvironment: import.meta.env.VITE_ENV
})
